/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ datum: NonNullable<unknown> }} Planning_Vakanties_Voor_VanInputs */

const nl_planning_vakanties_voor_van = /** @type {(inputs: Planning_Vakanties_Voor_VanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kies een dag op of na ${i?.datum}.`)
};

/**

* @param {Planning_Vakanties_Voor_VanInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_voor_van = /** @type {((inputs: Planning_Vakanties_Voor_VanInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Voor_VanInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_voor_van(inputs)
});
export { planning_vakanties_voor_van as "planning.vakanties.voor_van" }